import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import closeIcon from '../../assets/close-button.svg';

import './ModalDialog.css';

const CLOSE_BY_MODES = {
  any: 'any',
  closerequest: 'closerequest',
  none: 'none',
};

const ModalDialog = ({
  cancelable = true,
  children,
  onClose = () => { },
  show = false,
  hideCloseIcon = false,
}) => {
  const { t } = useTranslation('insurance');
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!dialogRef?.current) {
      return;
    }

    if (show) {
      dialogRef.current.showModal();
    } else {
      dialogRef.current.close();
    }
  }, [dialogRef, show]);

  const renderCloseButton = () => {
    if (hideCloseIcon) {
      return null;
    }

    return (
      <button
        className="Modal-dialog-button-close"
        onClick={onClose}
        type="button"
      >
        <img alt={t('closeModal')} src={closeIcon} />
      </button>
    );
  };

  return (
    <dialog
      ref={dialogRef}
      // by default, if has className appears even
      // with no open property defined... :question:
      className={show ? 'Modal-dialog-container' : ''}
      // eslint-disable-next-line react/no-unknown-property
      closedby={cancelable ? CLOSE_BY_MODES.closerequest : CLOSE_BY_MODES.none}
      onClose={onClose}
    >
      {renderCloseButton()}

      {children}
    </dialog>
  );
};

export { ModalDialog };
